import { Box, ClickAwayListener, Collapse } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type ExpandableSubmenuProps = {
  header?: ReactNode;
  content?: ReactNode;
  expandOnStart?: boolean;
  disableEditPanel?: boolean;
};

export const ExpandableSubmenu = ({ header, content, expandOnStart }: ExpandableSubmenuProps) => {
  const [isExpanded, setIsExpanded] = useState(expandOnStart);
  return (
    <>
      <ClickAwayListener onClickAway={() => setIsExpanded(false)}>
        <Box>
          <Box onClick={() => setIsExpanded(!isExpanded)}>{header}</Box>
          <Submenu>
            <Collapse in={isExpanded}>{content}</Collapse>
          </Submenu>
        </Box>
      </ClickAwayListener>
    </>
  );
};

type SubmenuProps = {
  children?: ReactNode;
};

export const Submenu = ({ children }: SubmenuProps) => {
  const [domReady, setDomReady] = useState(false);

  useEffect(() => {
    setDomReady(true);
  }, []);
  const container = document.getElementById('header-submenu') as HTMLElement;
  return domReady ? ReactDOM.createPortal(children, container) : null;
};
